import React from "react";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import Fab from "@material-ui/core/Fab";
import { withStyles } from "@material-ui/styles";
import ReportOption from "../ReportOption";
import { observer } from "mobx-react";
import { addReport } from "../../firestorter";
import AutoSuggestInput from "../AutoSuggest";
import { CONSTANTS } from "../../utils";
import ReportButtons from "../ReportButtons";

const classes = {
  panel: {
    backgroundColor: "#b14d9b",
    color: "white",
    textAlign: "center",
    padding: "20px",
  },
  reportButton: {
    marginTop: "1rem",
    width: "30%",
    fontSize: "1.4rem",
  },
  search: {
    width: "100%",
  },
  searchFab: {
    backgroundColor: "white",
    boxShadow: "none",
    marginBottom: "20px",
    width: "80%",
    "& .MuiFab-label": {
      justifyContent: "right",
      "& input": {
        border: "none",
      },
    },
  },
};

const ReportPanel = observer(
  class ReportPanel extends React.Component {
    constructor() {
      super();
      this.state = {
        score: null,
        location: null,
        _location: null,
        enableReport: false,
        hideText: false,
      };
    }
    componentWillMount() {
      // When coming from an already reported location

      this.setState(
        { hideText: true, _location: this.props.location },
        this.setReportLocation
      );
    }
    setReportScore(score, reporterScore) {
      this.setState(
        { score: score, reporterScore: reporterScore },
        this.updateEnableReport
      );
    }
    report() {
      // Update location score
      addReport(
        this.state.score,
        this.state.reporterScore,
        this.state.location
      );
      this.props.closePanel(false);
    }
    updateReportLocation(location) {
      this.setState({ _location: location }, this.updateEnableReport());
    }

    setReportLocation() {
      this.setState(
        { location: this.state._location },
        this.updateEnableReport()
      );
    }

    updateEnableReport() {
      const enable = this.state.score != null && !!this.state.location;
      this.setState({ enableReport: enable });
    }
    render() {
      const { classes } = this.props;
      const self = this;
      const enableReport = this.state.enableReport;
      const location = this.state.location;

      const content = location ? (
        <div>
          {this.state.hideText ? (
            ""
          ) : (
            <div>
              <h2>מה מצב הנקיון?</h2>
              <div style={{ marginBottom: "10px" }}>
                מי שגם מנקה, מקבל נקודות ותהילת עולם
              </div>
            </div>
          )}

          <ReportButtons
            disabled={!enableReport}
            report={this.report.bind(this)}
            setReportScore={this.setReportScore.bind(this)}
          />
        </div>
      ) : (
        <div>
          <h2>איפה אתם?</h2>
          <div style={{ marginBottom: "10px" }}>
            תוכלו לכתוב כאן איפה אתם מטיילים, או לסמן את המקום על המפה באמצעות
            לחיצה ארוכה
          </div>
          <Fab
            className={classes.searchFab}
            variant="extended"
            aria-label="search"
            disableFocusRipple={true}
            disableRipple={true}
          >
            <LocationOnIcon style={{ fontSize: "2.3rem" }} />
            <AutoSuggestInput
              className={classes.search}
              placeholder="איפה אתם?"
              onChange={this.updateReportLocation.bind(this)}
              locationFromMap={this.props.params}
            />
          </Fab>
          <div>
            <Fab
              className={classes.reportButton}
              variant="extended"
              aria-label="like"
              onClick={this.setReportLocation.bind(this)}
            >
              המשך
            </Fab>
          </div>
        </div>
      );

      return (
        <div className={classes.panel} role="presentation">
          {content}
        </div>
      );
    }
  }
);

export default withStyles(classes)(ReportPanel);
